import React from 'react'

const usePrefersReducedMotion = () => {
  const [reduced, setReduced] = React.useState(false)

  React.useEffect(() => {
    const media =
      typeof window !== 'undefined'
        ? window.matchMedia('(prefers-reduced-motion: reduce)')
        : null

    if (!media) {
      return undefined
    }

    const update = () => setReduced(Boolean(media.matches))
    update()

    if (media.addEventListener) {
      media.addEventListener('change', update)
      return () => media.removeEventListener('change', update)
    }

    media.addListener(update)
    return () => media.removeListener(update)
  }, [])

  return reduced
}

export default usePrefersReducedMotion
